var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34909 0.147034C11.1044 0.147034 14.159 3.20161 14.159 6.9569C14.159 8.72863 13.479 10.3445 12.3664 11.5573L14.5557 13.7421C14.7606 13.947 14.7613 14.2784 14.5564 14.4833C14.4543 14.5868 14.3194 14.6379 14.1851 14.6379C14.0515 14.6379 13.9173 14.5868 13.8145 14.4847L11.5987 12.2751C10.4331 13.2086 8.95518 13.7675 7.34909 13.7675C3.59381 13.7675 0.538528 10.7122 0.538528 6.9569C0.538528 3.20161 3.59381 0.147034 7.34909 0.147034ZM7.34909 1.196C4.17214 1.196 1.58749 3.77994 1.58749 6.9569C1.58749 10.1339 4.17214 12.7185 7.34909 12.7185C10.5254 12.7185 13.11 10.1339 13.11 6.9569C13.11 3.77994 10.5254 1.196 7.34909 1.196Z",
    fill: "#2C264B",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2da3dcf111a778ff8a816a53766cf0d4.svg";
export { ForwardRef as ReactComponent };